import processHook from './process-hook'
import authHook from './auth-hook'

export default router => {
  processHook(router)
  authHook(router)
}
